// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JW3U","buttons":"styles_buttons__1-bOG"};